module.exports = __webpack_public_path__ + "static/lime-logo-512b766a16b49ce7f8f6e10d5a20f84e.jpg";